import React from 'react'
import ErrorView from './ErrorView'

export default ({ errors }) => errors.map(err =>
  <ErrorView {...err} />
)


// WEBPACK FOOTER //
// ./src/modules/AppErrors/AppErrors.js